import { Component, computed, input, output } from '@angular/core';
import { ReportExport, ReportExportJobStatus } from '../../types';

@Component({
  selector: 'app-pan-report-export',
  templateUrl: './pan-report-export.component.html',
  styleUrl: './pan-report-export.component.scss',
  standalone: false,
})
export class PanReportExportComponent {
  public value = input.required<ReportExport>();

  public download = output<void>();
  public export = output<void>();

  public canRetry = computed(() => {
    const re = this.value();
    const retryable = this.retryableStatuses.indexOf(re.job_status) !== -1;
    const stalledAndRemoved = re.job_status === null && re.progress !== 1.0;
    return retryable || stalledAndRemoved;
  });

  public getJobStatusTooltip = computed(() => {
    const re = this.value();
    switch (re.job_status) {
      case 'Awaiting':
      case 'Processing':
        return 'The export job is running!';
      case 'Succeeded':
        return 'The export job has completed! Please download the report.';
      case 'Enqueued':
        return 'The export job is about to begin.';
      case 'Scheduled':
        return 'The export job is waiting in line (there may be too many export jobs running at the same time).';
      case 'Failed':
        return 'The export job failed. Please retry the export.';
      case 'Deleted':
        return 'The export job was deleted. Please retry the export.';
      case null:
        return `
          The export job was removed due to one of the following reasons:
            the application restarted,
            or the job had failed and has expired.
            Please retry the export.
        `.trim();
      default:
        return '';
    }
  });

  private readonly retryableStatuses: ReportExportJobStatus[] = ['Failed', 'Deleted'];
}
